/**
 * Determines the correct route for viewing a note based on its processing flow.
 *
 * V2 (thread_id present): `/note/{id}` — streaming handles progress inline
 * V1 completed:           `/note/{id}` — safe to view directly
 * V1 processing/unknown:  `/status/{id}` — legacy polling page
 */
export function getNoteRoute({
  note_id,
  thread_id,
  status,
}: {
  note_id: string;
  thread_id?: string | null;
  status?: string | null;
}): string {
  if (thread_id) return `/note/${note_id}`;
  if (status === 'completed') return `/note/${note_id}`;
  return `/status/${note_id}`;
}

/**
 * Where opening an encounter from a chart list should land (GDN-2437).
 *
 * - completed with a native note → the note surface, directly
 * - completed without one        → `/encounter/{id}/outputs`, the GDN-1979
 *   resolver. A migrated encounter carries its note as a clinical_note
 *   document, and the live `/encounters/{id}` page is both wrong for
 *   history and gated behind recording permissions.
 * - still pending/active         → `/encounters/{id}`, the live surface
 */
export function getEncounterOpenRoute({
  encounter_id,
  status,
  note_id,
}: {
  encounter_id: string;
  status?: string | null;
  note_id?: string | null;
}): string {
  if (status === 'completed') {
    return note_id ? `/note/${note_id}` : `/encounter/${encounter_id}/outputs`;
  }
  return `/encounters/${encounter_id}`;
}
